export const ActionTypes = {
  SET_MEMBERSHIPS: 'SET_MEMBERSHIPS'
};
